// extracted by mini-css-extract-plugin
export var button = "stylization-edit-form-module--button--U+UOH";
export var buttons = "stylization-edit-form-module--buttons--69aul";
export var cancelIcon = "stylization-edit-form-module--cancel-icon--ZCjlA";
export var checkIcon = "stylization-edit-form-module--check-icon--fyOEJ";
export var form = "stylization-edit-form-module--form--ieMeZ";
export var input = "stylization-edit-form-module--input--rtLvw";